import { AddBoxOutlined, CopyAllOutlined, DeleteOutlined, EditOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React, { FC } from 'react';
import { NavLevel } from '../NavigationComponent';
import styles from './NavActions.module.css';

export enum navActionEnum {
    toggle = 'toggle',
    add = 'add',
    edit = 'edit',
    archive = 'archive',
    duplicate = 'duplicate'
}

interface NavActionsProps {
    title: string,
    allowedActions: navActionEnum[],
    onAdd: () => void,
    onEdit: () => void,
    onArchive: () => void,
    onDuplicate: () => void,
}

const NavActions: FC<NavActionsProps> = ({ title, allowedActions, onAdd, onEdit, onArchive, onDuplicate }) => (
    <div className={styles.NavActions} data-testid="NavActions">
        {allowedActions.includes(navActionEnum.add) &&
            <Tooltip title={`${title} Toevoegen`}>
                <IconButton data-testid={`add-${title.toLowerCase()}`} color="primary" aria-label="toevoegen" component="span" onClick={onAdd}>
                    <AddBoxOutlined />
                </IconButton>
            </Tooltip>
        }
        {allowedActions.includes(navActionEnum.edit) &&
            <Tooltip title={`${title} Wijzigen`}>
                <IconButton data-testid={`edit-${title.toLowerCase()}`} color="primary" aria-label="wijzigen" component="span" onClick={onEdit}>
                    <EditOutlined />
                </IconButton>
            </Tooltip>
        }
        {allowedActions.includes(navActionEnum.duplicate) &&
            <Tooltip title={`${title} Dupliceren`}>
                <IconButton data-testid={`archive-${title.toLowerCase()}`} color="primary" aria-label="dupliceren" component="span" onClick={onDuplicate}>
                    <CopyAllOutlined />
                </IconButton>
            </Tooltip>
        }
        {allowedActions.includes(navActionEnum.archive) &&
            <Tooltip title={`${title} Archiveren`}>
                <IconButton data-testid={`archive-${title.toLowerCase()}`} color="primary" aria-label="archiveren" component="span" onClick={onArchive}>
                    <DeleteOutlined />
                </IconButton>
            </Tooltip>
        }
    </div>
);

export default NavActions;
